import { render } from "./BasicInfoModal.vue?vue&type=template&id=09c1dc64&scoped=true"
import script from "./BasicInfoModal.vue?vue&type=script&lang=js"
export * from "./BasicInfoModal.vue?vue&type=script&lang=js"

import "./BasicInfoModal.vue?vue&type=style&index=0&id=09c1dc64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c1dc64"]])

export default __exports__